// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-18T15:09:51+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190487
//    Project:        510
//    Environment:    3832 - master
//    MD5:            de13638ace9b8adc246aa2ad7d2fe0ed
//    Signature:      eyJpdiI6IkV1d3Z3U2dMNTRNNlhLZkhpNEUzSFE9PSIsInZhbHVlIjoiMTNBZXJCQjdNZXFCeGxsWE9JZjVCZzFFQmtMMWpkK3RCdmNJa1p4NE5WZllQZHJIenRiZFwvT25VZFN5Y3NYSGd4NGhkMHo1em93V2ZcL015Y29YMlZOdXd5VlNDcUhyZzBTWFd5R0JzVVhEN3hSUzFVeFZrQjFFRW01eDhDbjZobUtRaExwMjJGQ2lhUEREOW1tWkVBdGZRYjh2SENqNEtNOHdsSlhRbk84NVJpWUJnUTRCcDZCS0F5WmZqclR5VDBKKzBMV29oYVRtWStmeGpQUUFOYW43V1hnOEZlMnBwQndZdEU0U3RFeFQ5TVE0Z0NHbTloeWkwTzRWUThZTkxtOXBJQ1IrUHJTZUZTZTl0UXcwbURFSTgwUFFoT1wvOTlKWjNZV2hqdTEwTXRGWXd2SzRROHdRWTVRemdIZFlnRk9nUGl3Q0xEaFlNN2xjZHRocDlcL2hpY1VoQ3R3N24yOFdGU2lJYmxmUHVcL21FaUVwSXorMXhLNVVUWEZDdXVVbm9EeWxjUGJkNlwvNE1kaWFcLzdPZXRDZzFrWmxmelR0UE04alE0Wkk0QnFmVms9IiwibWFjIjoiNWVhMzA5Y2IxZDRjM2VkYjIyM2U3MThhM2JjMjgzMTA3YzZkNmFiNzEyNmVhMjM1ZWZkZTNhMzFkOGU1NWU5OSJ9
if (!customElements.get("insurance-cart-action")) {
  customElements.define(
    "insurance-cart-action",
    class extends HTMLElement {
      constructor() {
        super();
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.handleRemoveFromCart = this.handleRemoveFromCart.bind(this);
        this.handleWidgetCheckboxChange = this.handleWidgetCheckboxChange.bind(this);
      }

      connectedCallback() {
        this.sideCart = document.querySelector(".side-cart");
        this.addToCartButtons = this.querySelectorAll(".add-to-cart-button");
        this.widgetAddToCartButton = this.querySelector(".product-form-addon__widget-atc");
        this.removeFromCartButtons = this.querySelectorAll(".cart-row__remove");
        this.productForm = document.querySelector("product-form");
        this.widgetCheckboxes = document.querySelectorAll(".product-form-addon__checkbox");


        if (this.addToCartButtons) {
          this.addToCartButtons.forEach(btn => {
            btn.addEventListener("click", this.handleAddToCart);
          });
        }

        if (this.removeFromCartButtons) {
          this.removeFromCartButtons.forEach(btn => {
            btn.addEventListener("click", this.handleRemoveFromCart);
          });
        }

        if (this.widgetCheckboxes) {
          this.widgetCheckboxes.forEach(btn => {
            btn.addEventListener("change", this.handleWidgetCheckboxChange);
          });
        }
      }

      disconnectedCallback() {
        if (this.addToCartButtons) {
          this.addToCartButtons.forEach(btn => {
            btn.removeEventListener("click", this.handleAddToCart);
          });
        }

        if (this.removeFromCartButtons) {
          this.removeFromCartButtons.forEach(btn => {
            btn.removeEventListener("click", this.handleRemoveFromCart);
          });
        }
      }

      openSideCart() {
        document.documentElement.classList.add("drawer-open");
        document.body.classList.add("drawer-open");
        this.sideCart.classList.add("is-active");
      }

      addItemsToCart(payload) {
        return fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        })
          .then(response => {
            if (!response.ok) {
              return response.json().then(err => {
                throw new Error(err.description || err.message || "Cart error");
              });
            }
            return response.json();
          })
          .catch(error => {
            console.error("Fetch error:", error);
            throw error;
          });
      }

      async updateCartItemQuantity(id, quantity) {
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id, quantity })
          });

          if (!response.ok) {
            const err = await response.json();
            throw new Error(err.description || err.message || "Cart update error");
          }

          return await response.json();
        } catch (error) {
          console.error("Error updating product in cart:", error);
          throw error;
        }
      }

      async handleWidgetCheckboxChange(e) {
        const checkbox = e.currentTarget;
        const variantId = checkbox?.value?.trim();
        const isChecked = checkbox?.checked;

        if (!variantId) {
          console.error("Checkbox is missing a valid variant ID.");
          return;
        }

        if (checkbox.dataset.primary === "true") {
          const secondaryCheckboxes = document.querySelectorAll('[data-secondary="true"]');
          secondaryCheckboxes.forEach(cb => {
            cb.disabled = !isChecked;
            if (!isChecked) cb.checked = false;

            const label = cb.closest('label');
            if (label?.classList.contains('product-form-addon__checkbox-label')) {
              label.classList.toggle('active', isChecked);
            }
          });
        }

        if (checkbox.dataset.secondary === "true") {
          let label = checkbox.closest('label') || document.querySelector(`label[for="${checkbox.id}"]`);
          if (label?.classList.contains('product-form-addon__checkbox-label')) {
            label.classList.toggle('active', isChecked);
          }
        }

        if (this.widgetAddToCartButton) {
          this.widgetAddToCartButton.addEventListener("click", (e) => {
            e.preventDefault();
            const isCartPage = window.location.pathname.includes("/cart");

            const payload = { items: [] };
            const allCheckboxes = document.querySelectorAll('.product-form-addon__checkbox-label input.product-form-addon__checkbox');
            allCheckboxes.forEach(cb => {
              if (cb.checked) {
                const productType = cb.dataset.secondary === "true" ? "optional_insurance_product" : "insurance";
                payload.items.push({
                  id: cb.value,
                  quantity: 1,
                  properties: {
                    _main_product_handle: cb.dataset.mainProductHandle,
                    _product_type: productType,
                    _insurance_included: true
                  }
                });
              }
            });
            
            if (payload.items.length > 0) {
              this.addItemsToCart(payload)
                .then(() => {
                  if (!isCartPage) {
                    sessionStorage.setItem("openCartAfterReload", "true");
                    window.location.reload();
                  }else {
                    window.location.reload();
                  }
                })
                .catch(error => {
                  console.error("Error adding items to cart:", error);
                });
            } else {
              console.warn("No items selected to add to cart.");
            }
          });
        }
      }

      async handleRemoveFromCart(e) {
        const removeButton = e.currentTarget;
        const lineItemProductHandle = removeButton.closest('.cart-row');
        const productKey = lineItemProductHandle.dataset.itemKey;
        const productHandle = lineItemProductHandle.dataset.itemHandle;
        const isCartPage = window.location.pathname.includes("/cart");

        if (!productKey || !productHandle) {
          console.error("No product key or handle found on the remove button");
          return;
        }
        
        const cartItems = await this.fetchCartItems();
        if (!cartItems) {
          console.error("No cart data found");
          return;
        }

        const relatedProducts = cartItems.filter(item => {
            return item.properties && item.properties['_main_product_handle'] == productHandle
          }
        );

      const itemsToRemove = [
        { key: productKey, quantity: 0 },
        ...relatedProducts
          .filter(item => item.key !== productKey) // Prevent duplicates
          .map(item => ({ key: item.key, quantity: 0 }))
      ];

        if (itemsToRemove.length === 0) {
          console.error("No matching addon items found to remove.");
          return;
        }

        try {
          for (const item of itemsToRemove) {
            await this.removeProductFromCart(item.key, 0);
          }

          if (!isCartPage) {
            sessionStorage.setItem("openCartAfterReload", "true");
            window.location.reload();
          }else {
            window.location.reload();
          }

        } catch (error) {
          console.error("Error removing addon items:", error);
        }
      }

      async handleAddToCart() {
        if (!this.productForm) return;

        try {
          const productData = JSON.parse(this.productForm.getAttribute('product'));
          const variantID = productData.variants[0].id;
          const data = window.selectedInsuranceData || {};

          const payload = {
            items: [
              {
                id: variantID,
                quantity: 1,
                properties: {
                  "_main_product_handle": productData.handle,
                  "_product_type": "main_with_addon"
                }
              }
            ]
          };

          if (data.insurance_variant_id && data.insurance_variant_id > 0) {
            payload.items.push({
              id: data.insurance_variant_id,
              quantity: data.insurance_variant_qty || 1,
              properties: {
                _main_product_handle: productData.handle,
                _product_type: "insurance",
                _insurance_included: true
              }
            });
          }

          if (data.optional_product_id && data.optional_product_id > 0) {
            payload.items.push({
              id: data.optional_product_id,
              quantity: data.optional_product_qty || 1,
              properties: {
                _main_product_handle: productData.handle,
                _product_type: "optional_insurance_product",
                _insurance_included: true
              }
            });
          }

          await this.addItemsToCart(payload);
          sessionStorage.setItem("openCartAfterReload", "true");
          window.location.reload();
        } catch (error) {
          console.error("Error in handleAddToCart:", error);
        }
      }

      async fetchCartItems() {
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart.js`);
          if (!response.ok) throw new Error("Failed to fetch cart items");
          const data = await response.json();
          return data.items || [];
        } catch (error) {
          console.error("Error fetching cart items:", error);
          return [];
        }
      }

      async removeProductFromCart(id, quantity) {
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id, quantity })
          });

          if (!response.ok) {
            const err = await response.json();
            throw new Error(err.description || err.message || "Cart error");
          }

          return await response.json();
        } catch (error) {
          console.error("Error removing product from cart:", error);
          throw error;
        }
      }
    }
  );
}
